<template>
  <NotLogged
    :welcome="welcome"
    formTitle="Konfiguracja dwuetapowej autoryzacji"
    :afterMessage="message"
  >
    <template #form>

      <div v-if="recoveryCodes" class="pb-6">
        <div class="mb-4 text-sm text-gray-700">
          Zapisz poniższe kody odzyskiwania. Każdy z nich umożliwia dostęp do konta
          w przypadku utraty dostępu do aplikacji uwierzytelniającej.
        </div>

        <div class="bg-gray-100 border rounded p-3 font-mono text-sm mb-4">
          <div
            v-for="(code, index) in recoveryCodes"
            :key="index"
            class="leading-6"
          >
            {{ code }}
          </div>
        </div>

        <button
          class="btn btn-secondary w-full mb-2"
          @click="copyRecoveryCodes"
        >
          Skopiuj kody
        </button>

        <button
          class="btn btn-primary w-full"
          :disabled="!codesCopied"
          @click="finishSetup"
        >
          Zapisałem kody i rozumiem ich znaczenie
        </button>
      </div>

      <div v-else-if="setupCompleted" class="text-center">
        <div class="mb-4 text-green-600 font-medium">
          Konfiguracja dwuetapowej autoryzacji zakończona pomyślnie.
        </div>

        <div class="mb-6 text-sm text-gray-600">
          Wróć do ekranu logowania i zaloguj się ponownie.
        </div>

        <button
          class="btn btn-primary w-full rounded-sm"
          @click="goToLogin"
        >
          Wróć do logowania
        </button>
      </div>

      <form v-else class="pb-6" @submit.prevent="confirm" autocomplete="off">
        <div class="mb-4 text-sm text-gray-600">
          Zeskanuj kod QR w aplikacji Google Authenticator,
          a następnie wpisz wygenerowany kod.
        </div>

        <div class="flex justify-center mb-4">
          <div
            v-html="qrSvg"
            class="w-40 h-40 svg-wrapper"
          />
        </div>

        <input
          v-focus
          v-model="form.code"
          type="text"
          maxlength="6"
          placeholder="kod z aplikacji"
          :disabled="isBusy"
          required
        >

        <button
          type="submit"
          class="btn btn-primary w-full rounded-sm mt-3"
          :disabled="isBusy"
        >
          {{ isBusy ? 'Weryfikacja...' : 'Potwierdź' }}
        </button>
      </form>

    </template>
  </NotLogged>
</template>

<script>
import NotLogged from '../components/NotLogged.vue';
import TwoFactorService from '../services/TwoFactorService';

export default {
  name: 'TwoFactorSetupRequired',
  components: { NotLogged },

  data() {
    return {
      qrSvg: '',
      key: null,
      setupCompleted: false,
      recoveryCodes: null,
      codesCopied: false,
      form: {
        code: '',
      },
      isBusy: false,
      message: '',
      welcome: {
        content:
          'Wymagana jest konfiguracja dwuetapowej autoryzacji konta.',
        footer: 'Zespół Estimates Likwidacja Szkód',
      },
    };
  },

  mounted() {
    const { params } = this.$route;

    if (!params?.qrSvg || !params?.key) {
      this.$router.replace({ name: 'login' });
      return;
    }

    this.qrSvg = params.qrSvg;
    this.key = params.key;
  },

  methods: {
    confirm() {
      if (this.form.code.length !== 6) {
        this.message = 'Nieprawidłowy kod';
        return;
      }

      this.isBusy = true;
      this.message = '';

      TwoFactorService.confirmSetup({
        key: this.key,
        code: this.form.code,
      })
        .then(response => {
          this.recoveryCodes = response.data.recovery_codes;
        })
        .catch(error => {
          this.message = error.response?.data?.message || 'Nieprawidłowy kod';
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    copyRecoveryCodes() {
      navigator.clipboard.writeText(this.recoveryCodes.join('\n'));
      this.codesCopied = true;
    },
    finishSetup() {
      this.recoveryCodes = null;
      this.setupCompleted = true;
    },
    goToLogin() {
      this.$router.replace({
        name: 'login',
        query: { twoFactorConfigured: 1 },
      });
    },
  },
};
</script>

<style>
input {
  @apply bg-white border rounded-sm py-2 px-4 block w-full text-2xl my-2;
}
input:focus {
  @apply outline-none border-blue-300;
}
.svg-wrapper svg {
  @apply w-full h-auto;
}
</style>
